module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA9CAYAAABsrQNfAAAAGUlEQVQYlWP4//9/AxMDAwPDKEGYYGBgAABo3AP2t2Pq2wAAAABJRU5ErkJggg=="